<template>
  <div>
    <mdb-container>
      <div>
    <nav class="main-nav">
      <div class="logo">Admin Panel</div>
      <Burger></Burger>
    </nav>

    <Sidebar>
      <ul class="sidebar-panel-nav">
        <li>
          <mdb-icon icon="envelope" size="lg" class="orange-text"/>
          <router-link to="/admin/messages">Messages</router-link>
          <br>
        </li>
        <hr class="white">
        <li>
          <mdb-icon icon="plus" size="lg" class="orange-text"/>
          <router-link to="/admin/newPost">New Post</router-link>
          <br>
        </li>
        <hr class="white">
        <li>
          <mdb-icon icon="user" size="lg" class="orange-text"/>
          <router-link to="/admin/account">Account</router-link>
          <br>
        </li>
        <hr class="white">
        <li>
          <mdb-icon icon="sign-out-alt" size="lg" class="orange-text"/>
          <mdb-btn color="orange" size="sm" @click="logout()">Logout</mdb-btn>
          <br>
        </li>
      </ul>
    </Sidebar>
  </div>
  <div>
    <router-view/>
    <router-view class="view one" name="helper"></router-view>
    <router-view class="view two" name="Messages"></router-view>
    <router-view class="view three" name="NewPost"></router-view>
    <router-view class="view three" name="Account"></router-view>

  </div>
    </mdb-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import Sidebar from '@/components/Sidebar.vue'
import Burger from '@/components/Burger.vue'
import mdbContainer from 'mdbvue/lib/components/mdbContainer'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbBtn from 'mdbvue/lib/components/mdbBtn'

export default {
  components: {
    Sidebar,
    Burger,
    mdbContainer,
    mdbIcon,
    mdbBtn
  },
  methods: {
    logout () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    }
  }
}
</script>

<style scoped>

.logo {
  align-self: center;
  color: black;
  font-weight: bold;
  font-family: "Lato";
  font-size: 30px;
}

.main-nav {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0.8rem;
}

ul.sidebar-panel-nav {
  list-style-type: none;
}

ul.sidebar-panel-nav > li > a {
  color: #fff;
  text-decoration: none;
  font-size: 1.5rem;
  padding-bottom: 0.5em;
  padding-left: 20px;
}
.white{
  color: white
}
</style>
